import get from 'lodash/get';
import * as types from './constants';

const initialState = {
  loading: false,
  error: null,
  paymentReceiptData: {},
  feedbackAdded: false,
  feedbackAppId: '',
  fetchedEntity: {
    UAE_RESIDENT: [],
    COMPANY: [],
    NON_UAE_RESIDENT: [],
    GOVERNMENT_ENTITY: [],
  },
  entityCustomDetails: {},
  noResults: false,
  etisalatLead: {},
};

export default function commonReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.COMMON_ACTION_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.COMMON_ACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.COMMON_ACTION_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', null),
      };
    case types.COMMON_REDUCER_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.COMMON_REDUCER_CLEAR_DATA:
      return initialState;
    case types.FETCH_PAYMENT_RECEIPT:
      return {
        ...state,
        loading: true,
        error: null,
        paymentReceiptData: {},
      };
    case types.FETCH_PAYMENT_RECEIPT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        paymentReceiptData: get(action.payload, 'data'),
      };
    case types.DOWNLOAD_PAYMENT_RECEIPT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.CLEAR_PAYMENT_RECEIPT_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.HAPPINESS_METER_FEEDBACK:
      return {
        ...state,
        loading: true,
        feedbackAdded: false,
        error: null,
      };
    case types.HAPPINESS_METER_FEEDBACK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        feedbackAdded: true,
        feedbackAppId: get(action.payload, 'applicationId'),
      };
    case types.HAPPINESS_METER_FEEDBACK_ERROR:
      return {
        ...state,
        loading: false,
        feedbackAdded: false,
        error: get(action.payload, 'error'),
      };
    case types.HAPPINESS_METER_UPDATE_FLAG:
      return {
        ...state,
        loading: false,
        error: null,
        feedbackAdded: false,
      };
    case types.DOCUMENT_VIEW_POPUP:
      return {
        ...state,
        loading: true,
      };
    case types.DOCUMENT_VIEW_POPUP_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.DOCUMENT_VIEW_POPUP_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.FETCH_ENTITY_SUCCESS:
      return {
        ...state,
        loading: false,
        noResults: get(action.payload, 'noResults'),
        fetchedEntity: {
          ...state.fetchedEntity,
          ...action.payload,
        },
      };
    case types.RESET_FETCHED_ENTITY_DATA:
      return {
        ...state,
        error: null,
        noResults: false,
        fetchedEntity: {
          UAE_RESIDENT: [],
          COMPANY: [],
          NON_UAE_RESIDENT: [],
          GOVERNMENT_ENTITY: [],
        },
        entityCustomDetails: {},
      };
    case types.UPDATE_ENTITY_CUSTOM_DATA:
      return {
        ...state,
        entityCustomDetails: {
          ...state.entityCustomDetails,
          ...action.payload,
        },
      };
    case types.UPDATE_USERS_DATA_IN_DB_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.ETISALAT_SUBMIT_START:
      return {
        ...state,
        loading: true,
      };
    case types.ETISALAT_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        etisalatLead: get(action.payload, 'data'),
      };
    case types.ETISALAT_SUBMIT_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    default:
      return state;
  }
}
